import { GET_YLF_PRODUCTS, REGISTER_YLF } from "../../constants/api_constants";
import { handleApi } from "../utils";

export const getYlfProducts = async () => {
  return handleApi("get", GET_YLF_PRODUCTS);
};

export const registerYlf = async (values) => {
  return handleApi("post", REGISTER_YLF, values);
};
